import React, { Component } from 'react';
import { StandardDialog } from '../../dialogs';
import PropTypes from 'prop-types';
import { Button } from '../../../components';
import { ThemeColors } from '../../../theme';

class CourseCompletedDialog extends Component {
  renderRetryInfo() {
    if (this.props.cardsNotKnownCount == 0) {
      return null;
    }

    const progressText = `Noch ${this.props.cardsNotKnownCount} von ${this.props.cardsCount} zu lernen.`;

    return (
      <div>
        <p style={styles.text}>{progressText}</p>
        <Button
          style={{ ...styles.button, ...{ backgroundColor: ThemeColors.accent2Color } }}
          onClick={this.props.onRetry}
          label="Offene Kärtchen wiederholen"
          variant="contained"
          labelStyle={{ color: '#ffffff' }}
        />
      </div>
    );
  }

  titleText() {
    if (this.props.cardsNotKnownCount == 0) {
      return 'Alle Kärtchen gelernt!';
    }

    return 'Alle Kärtchen bearbeitet!';
  }

  // onGoToTest() {
  //   this.props.history.push(`/tests/${this.props.course.testId}`);
  //   this.props.close();
  // }

  onGoToTest = () => {
    const { course } = this.props;
    const testRuns = this.props.testRuns;
    const openRunForTest = testRuns.find(t => t.testId === course.testId);
    if (openRunForTest) {
      this.props.loadTest({ id: course.testId });
      this.props.setTestRun(openRunForTest);
    } else {
      this.props.startNewTestRun({ id: course.testId });
    }

    this.props.history.push(`/tests/${this.props.course.testId}`);
    this.props.close();
  }

  renderGoToTestButton() {
    if (!this.props.course || !this.props.course.testId) {
      return null;
    }

    return (
      <Button
        style={styles.button}
        onClick={this.onGoToTest.bind(this)}
        variant="contained"
        label="Zum Test"
        color="secondary"
        labelStyle={{ color: '#ffffff' }}
      />
    );
  }

  render() {
    return (
      <StandardDialog
        modal
        onAbort={() => alert('abort')}
        open={this.props.open}
        titleStyle={styles.text}
        title={this.titleText()}
      >

        {this.renderRetryInfo()}
        <Button
          style={styles.button}
          onClick={this.props.onRestart}
          variant="contained"
          label="Kurs neu starten"
          color="secondary"
          labelStyle={{ color: '#ffffff' }}
        />

        <Button
          style={styles.button}
          onClick={this.props.onCoursesSelected}
          label="Zur Kursübersicht"
          variant="contained"
          color="secondary"
          labelStyle={{ color: '#ffffff' }}
        />
        {this.renderGoToTestButton()}
      </StandardDialog>
    );
  }
}

CourseCompletedDialog.propTypes = {
  open: PropTypes.bool.isRequired,
};

const styles = {
  button: {
    width: '100%',
    marginTop: 20,
  },
  text: {
    textAlign: 'center',
  },
};

export default CourseCompletedDialog;



// WEBPACK FOOTER //
// ./src/app/main/dialogs/course-completed/course-completed.js